import React from "react";
import ReactDOM from "react-dom";
// import { hot } from "react-hot-loader/root";
import { Switch, Route, BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

// import { RematchRootDispatch, RematchRootState } from "models/utils";

import { store } from "store";
import LayoutContainer from "./layout";

import ImageManager from "containers/image/imageManager/imageManager";

// @import '~antd/dist/antd.compact.css';
// import Editor from "./editor";

import * as serviceWorker from "./serviceWorker";
import { ConfigProvider } from "antd";
import locale from "antd/es/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <ConfigProvider locale={locale}>
        <Switch>
          <Route path="/workbench" component={LayoutContainer} />
          <Route path="/imagemanager" component={ImageManager} />
          <Route path="/login" component={() => <div>login</div>} />
          <Route path="*" component={() => <div>404</div>} />
        </Switch>
      </ConfigProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
